import { render, staticRenderFns } from "./VoipExtensions.vue?vue&type=template&id=4cdc71c8&"
import script from "./VoipExtensions.vue?vue&type=script&lang=js&"
export * from "./VoipExtensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports